module.exports = __webpack_public_path__ + "static/media/skip.2c72e8f1.png";